import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { FieldBase } from '@atlassian/help-center-common-component/fields/field-base';
import type { FieldFormProps, AttachmentFile } from '@atlassian/help-center-common-component/fields/types';
import i18n from './messages';
import { Error } from './styled';

export interface Props extends FieldFormProps<AttachmentFile[]> {
    mediaApiError?: string;
}

const RequestCreateAttachmentFieldError: React.StatelessComponent<Props> = ({
    label,
    description,
    required,
    errorMessage,
    mediaApiError,
    id,
}) => {
    return (
        <FieldBase htmlFor={id} label={label} description={description} required={required} errorMessage={errorMessage}>
            <Error>{mediaApiError || <FormattedMessage {...i18n.genericError} />}</Error>
        </FieldBase>
    );
};

export default RequestCreateAttachmentFieldError;
